if(!customElements.get('collection-filters') && !customElements.get('collection-filters-tags')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.form = this.querySelector('form');
      this.summary = this.querySelector('.summary');
      this.documentClickHandler = this.documentClick.bind(this);
      this.applyBtn = this.querySelector('.apply-filters');
      this.clearAllBtn = this.querySelector('.clear-filters');
      this.ajax = true;

      if(this.dataset.open && this.dataset.mainFilters == "true") {
        this.showFilters();
      }
      this.form.addEventListener('submit', (e)=>{
        e.preventDefault();
      });
      this.pageManager.querySelector('.open-filters').addEventListener('click', ()=>{
        this.showFilters();
      });
      
      this.querySelector('.close-filters')?.addEventListener('click', ()=>{
        this.hideFilters();
      });

      //this.bindDropdown();
      
    }

    bindDropdown(){
      if($s.media.isMediumDown) return;

      this.querySelectorAll('.filters-inner .group').forEach((obj) => {
        obj.addEventListener('click', () => {
          if(obj.classList.contains('active')){
            this.classList.remove('active');
            obj.classList.remove('active');
            obj.querySelector('.list').style.display = 'none';
            return;
          }

          this.closeAll();

          var filterList = obj.querySelector('.list');
          this.classList.add('active');
          obj.classList.add('active');
          obj.querySelector('.list').style.display = 'block';
          this.style.setProperty('--filters-list-height', `${filterList.offsetHeight}px`)

        })
      })

      document.addEventListener('click', (e)=>{
        if(!this.contains(e.target)) {
          this.closeAll();
        }
      });
    }

    closeAll(){
      this.querySelectorAll('.filters-inner .group').forEach((obj) => {
        this.classList.remove('active');
        obj.classList.remove('active');
        obj.querySelector('.list').style.display = 'none'; 
      })
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
    }

    documentClick(e) {
      if(!this.contains(e.target)) {
        this.hideFilters();
      }
    }

    isOpen() {
      return this.classList.contains('open');
    }

    showFilters() {
      $s.closeModal();
      $s.showOverlay();
      this.classList.add('open');
      $s.trapFocus(this);
      setTimeout(()=>{
        document.addEventListener('click', this.documentClickHandler);
      }, 100);
    }

    hideFilters() {
      $s.hideOverlay();
      this.classList.remove('open');
      $s.removeTrapFocus();
      document.removeEventListener('click', this.documentClickHandler);
    }
  }

  if(!customElements.get('collection-filters')) {
    class CollectionFilters extends CollectionFiltersAbstract {
      constructor() {
        super();

        this.querySelectorAll('input').forEach((option)=>{
          option.addEventListener('change', (e)=>{
            if (e.target.checked) {
              const paramGroup = e.target.closest('[data-param]');
              if (paramGroup) {
                paramGroup.querySelectorAll('input').forEach((input) => {
                  if (input !== e.target) {
                    input.checked = false;
                  }
                });
              }
            }
            this.filterResults();
          });
        });
        this.priceSlider = null;
        this.initSummary();
        this.bindMobileBtns();
        this.createPriceSlider();
      }

      disconnectedCallback() {
        // Destroy the price slider if it exists
        if (this.priceSlider) {
          this.priceSlider.destroy();
          this.priceSlider = null;
        }
        
        // Remove event listeners from inputs
        this.querySelectorAll('input').forEach((option) => {
          option.removeEventListener('change', this.filterResults);
        });
        
        // Unbind mobile buttons
        this.applyBtn?.removeEventListener('click', this.hideFilters);
        this.clearAllBtn?.removeEventListener('click', this.clearAllFilters);
        
        // Unbind summary buttons
        if (this.summary) {
          this.summary.querySelectorAll('button').forEach((button) => {
            button.removeEventListener('click', this.filterResults);
          });
        }
      }

      createPriceSlider(){
        this.behaviourSlider = this.querySelector('#filterPrice');
        this.filterMinSelector = this.querySelector('#filter-price-min');
        this.filterMaxSelector = this.querySelector('#filter-price-max');
        this.filterMinPrice = parseInt(this.filterMinSelector.value || 0);
        this.filterMaxPrice = parseInt(this.filterMaxSelector.value || 0);
        this.maxPrice = parseInt(this.querySelector('.price-filter').getAttribute('data-max'));
        this.priceSlider = noUiSlider.create(this.behaviourSlider, {
          start: [this.filterMinPrice || 0, this.filterMaxPrice || this.maxPrice],
          step: 10,
          behaviour: 'drag',
          tooltips: true,
          connect: true,
          range: {
            'min': 0,
            'max': this.maxPrice
          }
        });
        this.priceSlider.on('change', (values) => {
          this.filterMinSelector.value = values[0];
          this.filterMaxSelector.value = values[1];
          this.filterResults();
        });
      }

      bindMobileBtns(){
        this.applyBtn?.addEventListener('click', this.hideFilters.bind(this));
        this.clearAllBtn?.addEventListener('click', this.clearAllFilters.bind(this));
      }

      clearAllFilters(){
        this.querySelectorAll('.group input').forEach((element)=>{
          element.value = '';
          element.checked = false;
        });
        this.filterResults();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  this.querySelectorAll('.group input').forEach((element)=>{
                    element.value = '';
                    element.checked = false;
                  });
                } else {
                  this.querySelector('#'+button.dataset.optionId).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
      }

      getSearchParams() {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);

        var params = new URLSearchParams();
        const keys = Array.from(searchParams.keys()).filter((x, i, a) => a.indexOf(x)==i);
        keys.forEach((key)=>{
          let values = searchParams.getAll(key);
          if(values.find(x=>x!="")) {
            params.set(key, values.join(','));
          }
        });

        var currenSearch = new URLSearchParams(location.search);
        if(currenSearch.has('sort_by')) {
          params.set('sort_by', currenSearch.get('sort_by'));
        }

        return params;
      }

      filterResults() {
        var url;
        var params = this.getSearchParams();
        var paramsString = params.toString().replace(/%2C/g, ',');
        if(this.ajax) {
          $s.showLoadingOverlay();
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              $s.showLoadingOverlay();
              doc.querySelector('.collection-filters').classList.add('open');
              doc.querySelector('.collection-filters').dataset.open = true;
            }
          });
        } else {
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          location = url;
        }
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  if(!customElements.get('collection-filters-tags')) {
    class CollectionFiltersTags extends CollectionFiltersAbstract {
      constructor() {
        super();
        this.baseUrl = location.origin + this.dataset.baseUrl;

        this.querySelectorAll('.item a').forEach((link)=>{
          link.addEventListener('click', (e)=>{
            e.preventDefault();
            this.filterResults(link.href);
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.clearAll) {
                var url = new URL(this.baseUrl);
                var currentUrl = new URL(location.href);
                url.search = currentUrl.search;
                this.filterResults(url.toString());
              } else {
                this.querySelector('#'+button.dataset.optionId).closest('a').dispatchEvent(new Event('click', {bubbles: true}));
              }
            });
          });
        }
      }

      filterResults(url) {
        if(this.ajax) {
          $s.showLoadingOverlay();
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              doc.querySelector('.collection-filters').dataset.open = true;
            }
          });
        } else {
          location = url;
        }
      }
    }
    customElements.define('collection-filters-tags', CollectionFiltersTags);
  }
}

if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.dropdown = this.querySelector('#sort-by');
      this.sortLabel = this.querySelector('.open-sort-by')
      this.ajax = true;

      var search = new URLSearchParams(location.search)
      this.dropdown.value = search.get('sort_by') || this.dataset.sortBy;


      this.sortLabel.addEventListener('click', ()=>{
        this.toggleSort();
      });

      this.dropdown.addEventListener('change', ()=>{
        var search = new URLSearchParams(location.search); //get new instance
        search.set('sort_by', this.dropdown.value);
        search.delete('page');
        var paramsString = search.toString();
        paramsString = paramsString.replace(/%2C/g,',');

        if(this.ajax) {
          $s.showLoadingOverlay();
          const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location.search = paramsString;
        }
      });

    }

    toggleSort(){
      this.dropdown.classList.toggle("sort-visible");
      this.sortLabel.classList.toggle("selected")
    }
  }
  customElements.define('collection-sort', CollectionSort);
}